import React from 'react';
import GrowthbookFlagProtectedRoute from './GrowthbookFlagProtectedRoute';
import StaticFlagProtectedRoute from './StaticFlagProtectedRoute';
import ConditionalWrapper from 'src/components/ConditionalWrapper';
import { StaticFlags } from 'src/common/hooks/useStaticFlags/StaticFlagsHook.types';
import { JSONValue } from '@growthbook/growthbook-react';
import { FEATURE_FLAGS_TYPE } from 'src/utils/growthBook/growthBook.constants';

type CommonProps = {
  expectedValue: 'on' | 'off' | JSONValue;
  redirectTo?: string;
  children: React.ReactNode;
};

export type GrowthbookProps = {
  static?: never;
  flag: keyof FEATURE_FLAGS_TYPE;
} & CommonProps;

export type StaticProps = {
  static: true;
  flag: StaticFlags;
} & CommonProps;

export type FlagProtectedRouteProps = GrowthbookProps | StaticProps;

const FlagProtectedRoute: React.FC<FlagProtectedRouteProps> = ({
  static: isStatic,
  children,
  ...rest
}) => {
  return (
    <ConditionalWrapper
      condition={!!isStatic}
      wrapper={(c) => (
        <StaticFlagProtectedRoute {...(rest as StaticProps)}>
          {c}
        </StaticFlagProtectedRoute>
      )}
      elseWrapper={(c) => (
        <GrowthbookFlagProtectedRoute {...(rest as GrowthbookProps)}>
          {c}
        </GrowthbookFlagProtectedRoute>
      )}
    >
      {children}
    </ConditionalWrapper>
  );
};

export default FlagProtectedRoute;
